import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminWildService } from '@services/adminWildService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminWildsIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminWildService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminWildService: AdminWildService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-wilds-new', this.dom, () => {
            this.adminWildService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminWildService,
            {
                entityKey: 'wilds',
                fetchData: (params) =>
                    this.adminWildService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                    params.set('country_id', this.countryId);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (wild) => {
                        this.adminWildService
                            .editDialog(wild, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminWildsIndexController = app.controller(
    'adminWildsIndexController',
    AdminWildsIndexController,
);
